import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'
import pluralize from '../../utils/pluralize'

export default function getConstants(p = {}) {

    const name = 'partner'
    const n = name
    const N = capitalize(n)
    const ns = pluralize(name)
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Meghívó létrehozása',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Partnerek törlése',
            ['accept' + N + 'Text']: 'Elfogadás és kredit jóváírása',

            // - a meghívó oldal (story) szövegei -

            [n + 'StoryNextLabel']: 'Tovább',
            [n + 'StoryStep1NextLabel']: 'Kezdhetjük',
            [n + 'StoryBackLabel']: 'Vissza',
            [n + 'StorySubmitLabel']: 'Beküldöm',
            [n + 'LegalAcceptLabel']: 'Elfogadom',
            [n + 'LegalCancelLabel']: 'Bezárás',

            // A lépés fölé kerülő H1. Csak ott van, ahol értelme van - a többi lépésnél nincs.
            [n + 'StoryStep1Heading']: 'Üdvözlünk Magyarország legnagyobb takarító közösségében!',
            [n + 'StoryStep1Title']: 'Indul a Takarító munkák partnerprogram',
            [n + 'StoryStep1Text']: 'Ha ezt a felületet látod, akkor az azt jelenti, hogy a céged jogosult arra, hogy részt vegyen a Partner programunkban. Néhány rövid lépésben megmutatjuk, hogyan működik a program, majd elkérünk pár adatot a beállításhoz. Pár perc az egész.',

            [n + 'StoryStep2Title']: 'Ingyen kreditet adunk a hirdetéseidhez',
            [n + 'StoryStep2Text']: 'A partnerprogram ideje alatt ajándék kreditet kapsz, amelyből ingyenesen adhatsz fel takarítói álláshirdetéseket az oldalon. A kreditkeretet egyedileg, a megadott adataid alapján állítjuk be.',

            [n + 'StoryStep3Title']: 'Egy egyszerű szabály',
            [n + 'StoryStep3Text']: 'Próbáld ki az oldalt, és tartsd be a csoport szabályát: először add fel a hirdetést a Takarító munkák oldalán, utána oszd meg a közösségünk Facebook-csoportjaiban. Így a csoport tagjai egy helyen láthatják az összes részletet, és jelentkezni is egyszerűen tudnak.',

            [n + 'StoryStep4Title']: 'Céged adatai',
            [n + 'StoryStep4Text']: 'Add meg a céged adatait, hogy egyértelműen azonosítani tudjunk. Ezeket az adatokat elmentjük a fiókodhoz, így egy esetleges későbbi kredit vásárlásnál már meglesznek.',

            [n + 'StoryStep5Title']: 'Átlagosan mennyi pozícióra keresel takarítót egy hónapban?',
            [n + 'StoryStep5Text']: 'Add meg, átlagosan hány hirdetést szeretnél feladni havonta. Ez alapján tudjuk meghatározni, mekkora kreditkeretet érdemes biztosítanunk neked.',

            [n + 'StoryStep6Title']: 'A fiókod',
            [n + 'StoryStep6Text']: 'Ezekkel az adatokkal tudsz majd belépni, és ezen az e-mail-címen tudunk kapcsolatba lépni veled. Ha már van fiókod ezzel az e-mail-címmel, add meg a meglévő jelszavadat, és összekapcsoljuk a fiókodat a partnerprogrammal.',

            // A kalkuláció szövegei. A ${...} helyeket a komponens tölti ki.
            [n + 'PlanSummaryJobs']: ({ jobs, months }) => `${jobs} hirdetés havonta X ${months} hónap`,
            [n + 'PlanSummaryCredit']: ({ credit }) => `${credit} kredit`,
            [n + 'PlanSummaryValue']: ({ price, months }) => `Ez normál esetben ${price} Ft + áfa értékű kredit lenne, a partnerprogramban viszont ajándékba adjuk. A keretet ${months} hónapon keresztül használhatod fel hirdetésfeladásra és kiemelésekre.`,

            [n + 'StateSubmittedTitle']: 'Feldolgozás alatt',
            [n + 'StateSubmittedText']: 'Megkaptuk az adataidat, köszönjük! Hamarosan átnézzük, és ha minden rendben, jóváírjuk a krediteket a fiókodban. Erről e-mailben értesítést küldünk. Addig is elkészítheted az első hirdetésedet, amit piszkozatként elment a rendszer, és később, a kreditek jóváírása után aktiválhatod.',
            [n + 'StateAcceptedTitle']: 'Köszöntünk a partnereink között!',
            [n + 'StateAcceptedText']: 'A fiókodba jóváírtunk',
            // A kredit összege a mondat közepén, vastagon jelenik meg; ez a szó tartozik hozzá.
            [n + 'StateAcceptedCreditWord']: 'kreditet',
            [n + 'StateAcceptedTextAfterCredit']: ({ months }) => `. A következő ${months} hónapban ezt a keretet hirdetésfeladásra és kiemelésre használhatod. Amíg a program tart, az egyenleged erejéig minden hirdetési szolgáltatásunk ingyenes számodra.`,
            [n + 'StateAcceptedNoCreditText']: 'A partnerprogramba felvettünk, a kreditet hamarosan jóváírjuk.',

            [n + 'GoToNewJobLabel']: 'Hirdetés feladása',
            [n + 'GoToAccountLabel']: 'A fiókom',
            [n + 'GoToUserAccountLabel']: 'Felhasználói fiók',

            [n + 'Rule1']: 'Add fel a hirdetést a Takarító munkák oldalán.',
            [n + 'Rule2']: 'Készítsd el a hirdetésed szövegét, amit megosztasz majd a közösségünk csoportjaiban. A szövegbe illeszd be a hirdetés linkjét, így automatikusan jóváhagyást kap a hirdetésed. Használhatsz saját képet a bejegyzésedhez, sőt ezt javasoljuk is, mert a Facebook algoritmusa jobban preferálja, mint a hivatkozások nézőképét - a lényeg, hogy a szövegben legyen benne a hivatkozás.',
            [n + 'Rule3']: 'Oszd meg közösségünk Facebook-csoportjaiban.'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Partnerek',
            ['my' + Ns + 'Menu']: 'Partnereim',
            ['new' + N + 'Menu']: 'Új partner meghívó',
            [ns + 'Menu']: 'Partnerek',
            ['deleted' + Ns + 'Menu']: 'Törölt partnerek',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt partnerek',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'A partner meghívó létrejött',
            ['save' + N + 'SuccessMessage']: 'A partner mentésre került',
            ['delete' + N + 'Success']: 'A partner törölve lett',
            ['delete' + Ns + 'Success']: 'A partnerek törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törlöd a partnert?',
            ['delete' + Ns + 'Question']: 'Biztosan törlöd a partnereket?',
            ['accept' + N + 'Success']: 'A partner elfogadva, a kredit jóváírva',
            ['accept' + N + 'Question']: 'Elfogadod a partnert, és jóváírod neki a beállított kreditet?',
            ['thereAreNo' + Ns]: 'Nincsenek partnerek',
            [n + 'SubmitSuccessMessage']: 'Köszönjük, megkaptuk az adataidat'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Partnerprogram',
            [ns + 'Title']: 'Partnerek',
            ['new' + N + 'Title']: 'Új partner meghívó',
            ['edit' + N + 'Title']: 'Partner szerkesztése',
            ['user' + Ns + 'Title']: 'Partnerek',
            ['userDeleted' + Ns + 'Title']: 'Törölt partnerek',
            ['my' + Ns + 'Title']: 'Partnereim',
            ['myDeleted' + Ns + 'Title']: 'Törölt partnereim',

            ['dialogDelete' + N + 'Title']: 'Partner törlése',
            ['dialogAccept' + N + 'Title']: 'Partner elfogadása',
            ['dialogDelete' + Ns + 'Title']: 'Partnerek törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            // A keretrendszer a `missingData` címkét mutatja, amíg a rekord nincs "validálva"
            // (itt: amíg a partner nem küldte be az adatait) - ez nálunk a kiküldött meghívó.
            // A `created` címke ezután, a jóváhagyás előtt látszik: ez a feldolgozás alatti állapot.
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt partnerek',
            ['deleted' + Ns + 'Title']: 'Törölt partnerek',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok'
        }
    }
}
